// extracted by mini-css-extract-plugin
module.exports = {"block":"loadBlock_block__2CZgp","fadeIn":"loadBlock_fadeIn__oj7qg"};